import { render, staticRenderFns } from "./partgroups.vue?vue&type=template&id=a7d7ec24&scoped=true&lang=pug"
import script from "./partgroups.vue?vue&type=script&lang=js"
export * from "./partgroups.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7d7ec24",
  null
  
)

/* custom blocks */
import block0 from "./partgroups.vue?vue&type=custom&index=0&blockType=router"
if (typeof block0 === 'function') block0(component)

export default component.exports